/**
 * Store listings that sell the same Autel hardware a second time, under a
 * different tier (Warren, 2026-10-02, "Sell it under Home").
 *
 * The network-ready AC Elite Commercial (Autel part MCC50AHI) is listed twice:
 *   - MCC50AHI under Commercial AC (tier commercial_ac): a commercial order,
 *     handed off to commissioning.
 *   - MCC50AHI-HOME under Home Charging (tier home): a home order. The buyer
 *     registers the charger in My Home and gets the residential setup email;
 *     there is no commissioning handoff.
 *
 * Product.part_number is unique, and order lines do not snapshot the tier
 * (the delivered email and the admin handoff check look the tier up from
 * Product by part number), so the home listing needs its own part number.
 * Autel only knows MCC50AHI, so the ops fulfillment email and the shipping
 * class use supplierPartNumber(). A home order never goes on a supplier PO:
 * the procurement routes refuse to link one (a PO reserves factory
 * identities, which blocks the buyer's My Home registration).
 *
 * Explicit map, the same pattern as the per-SKU maps in storeShipping.ts. Add
 * a row here only together with its seed row (scripts/_lib/storeCatalogSeed.ts).
 */
/** The Home Charging listing of the network-ready AC Elite Commercial. */
export const HOME_NETWORK_LISTING_PART = 'MCC50AHI-HOME';
/** Listing part number -> the Autel part number it fulfills as. */
export const LISTING_SUPPLIER_PART = {
    [HOME_NETWORK_LISTING_PART]: 'MCC50AHI',
};
/** The Autel part number to order for a catalog part number: the mapped part
 *  for a second listing, else the part number itself. */
export function supplierPartNumber(partNumber) {
    return LISTING_SUPPLIER_PART[partNumber] ?? partNumber;
}
/** True when the part number is a second listing of other Autel hardware. */
export function isListingAlias(partNumber) {
    return Object.prototype.hasOwnProperty.call(LISTING_SUPPLIER_PART, partNumber);
}
/** True for the Home Charging listing of the network-ready charger: the one
 *  home line the buyer registers in My Home and connects to the network.
 *  The AC Elite Home is tier home too but does not connect, so the setup
 *  email, the ops "buyer registers it in My Home" note and the factory PO
 *  refusal key on this, not on the tier alone. */
export function isHomeNetworkListing(partNumber) {
    return partNumber === HOME_NETWORK_LISTING_PART;
}
//# sourceMappingURL=storeListings.js.map